<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="18">
				<div class="centext-box">
					<div class="header">
						新增用户
					</div>
					<div style="padding: 30px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="所属软件" prop="software">
								<el-select v-model="ruleForm.software" clearable placeholder="请选择所属软件"
									style="width: 300px;margin-right: 10px;" size="small">
									<el-option v-for="(item,index) in software_list" :key="index" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="账号" prop="username">
								<el-input type="text" placeholder="请输入账号" size="small" v-model="ruleForm.username"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="密码" prop="password">
								<el-input type="text" placeholder="请输入密码" size="small" v-model="ruleForm.password"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="允许多端数量" prop="max_num">
								<div slot="label" style="display: flex;align-items: center;">
									<span>允许多端数量</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(0)">
								</div>
								<el-input-number size="small" v-model="ruleForm.max_num" controls-position="right"
									:min="0" :max="999"></el-input-number>
							</el-form-item>

							<el-form-item label="配置">
								<div slot="label" style="display: flex;align-items: center;">
									<span>配置</span>
									<img src="../../assets/question.png" style="width: 20px;height: 20px;margin-left: 5px;cursor: pointer;" @click="openMsg(1)">
								</div>
								<el-input type="text" placeholder="请输入配置" size="small" v-model="ruleForm.config"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="到期时间" prop="endtime">
								<el-date-picker size="small" v-model="ruleForm.endtime" type="datetime"
									placeholder="选择到期时间" style="width: 300px;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="备注">
								<el-input type="text" placeholder="请输入备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">立即创建</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 0px 10px 0px 10px;font-size: 14px;text-align: center;">
				{{msg}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				dialogCodeVisible:false,
				msg:'',
				msg_list:[
					'意思是该账号允许几个端同时登陆',
					'账号配置可以用来做很多自定义功能，没有用到请忽略。',
				],
				ruleForm: {
					username: '',
					password: '',
					one: '',
					endtime: '',
					max_num: '',
					software: '',
					config: '',
				},
				rules: {
					software: [{
						required: true,
						message: '请选择所属软件',
						trigger: 'change'
					}],
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					max_num: [{
						required: true,
						message: '请输入允许多端数量',
						trigger: 'blur'
					}],
					endtime: [{
						required: true,
						message: '请选择到期时间',
						trigger: 'change'
					}],
					config: [{
						required: true,
						message: '请输入配置',
						trigger: 'blur'
					}],
				},
				type_config: {},
				software_list: [],
				card_state_conf: {},
			}
		},
		created() {
			this.resetForm()
			this.getData()
		},
		methods: {
			openMsg(index){
				this.msg = this.msg_list[index]
				setTimeout(()=>{
					this.dialogCodeVisible = true
				},100)
			},
			getData() {
				this.$H.post('verify_center/v1_0_1.Software/list').then(res => {
					if(!res.data) return;
					this.software_list = res.data.list;
				});
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('/verify_center/v1_0_1.User/Create', this.ruleForm).then(res => {
							if(!res.data) return;
							this.$message.success('添加成功')
							this.$emit('back')
						}).catch(err => {
							console.log(err)
							this.$emit('back')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>